export default "__VITE_ASSET__BYkRrCk9__"